export default __webpack_public_path__ + "static/media/newYear4.96189ac7.jpg";